/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer the three most common percentage questions instantly, then jump to a dedicated calculator for increases, decreases, differences, tips or discounts.`)
};

const es_pct_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde al instante las tres preguntas de porcentaje más comunes y luego pasa a una calculadora dedicada para aumentos, disminuciones, diferencias, propinas o descuentos.`)
};

const de_pct_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantworte die drei häufigsten Prozentfragen sofort und wechsle dann zu einem eigenen Rechner für Anstieg, Rückgang, Unterschied, Trinkgeld oder Rabatt.`)
};

const nl_pct_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantwoord direct de drie meest gestelde percentagevragen en ga daarna naar een speciale calculator voor stijgingen, dalingen, verschillen, fooien of kortingen.`)
};

const fr_pct_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répondez instantanément aux trois questions de pourcentage les plus courantes, puis accédez à un calculateur dédié pour les augmentations, diminutions, différences, pourboires ou réductions.`)
};

const it_pct_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispondi subito alle tre domande più comuni sulle percentuali, poi passa a un calcolatore dedicato per aumenti, cali, differenze, mance o sconti.`)
};

const pt_br2_pct_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responda instantaneamente às três perguntas de porcentagem mais comuns, depois vá direto a uma calculadora dedicada para aumentos, diminuições, diferenças, gorjetas ou descontos.`)
};

const pt_pct_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responda instantaneamente às três perguntas mais comuns sobre percentagens e depois avance para uma calculadora dedicada a aumentos, diminuições, diferenças, gorjetas ou descontos.`)
};

const ja_pct_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最もよくある3つのパーセントの質問に即座に答え、増加・減少・差・チップ・割引の専用計算機にも進めます。`)
};

const zh_pct_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即时解答三种最常见的百分比问题，然后跳转至专门的计算器计算增长、减少、差异、小费或折扣。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_intro", locale)
	if (locale === "en") return en_pct_hub_intro(inputs)
	if (locale === "es") return es_pct_hub_intro(inputs)
	if (locale === "de") return de_pct_hub_intro(inputs)
	if (locale === "nl") return nl_pct_hub_intro(inputs)
	if (locale === "fr") return fr_pct_hub_intro(inputs)
	if (locale === "it") return it_pct_hub_intro(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_intro(inputs)
	if (locale === "pt") return pt_pct_hub_intro(inputs)
	if (locale === "ja") return ja_pct_hub_intro(inputs)
	return zh_pct_hub_intro(inputs)
};